import { createApiClient } from "@odus/api-client";

import { env } from "./env";

/** Cliente da API (tipos gerados do OpenAPI). O token da sessão entra na S3. */
export const api = createApiClient({ baseUrl: env.apiUrl });
